import { render } from "./3.Austria.vue?vue&type=template&id=fb52e2d6&scoped=true"
import script from "./3.Austria.vue?vue&type=script&lang=js"
export * from "./3.Austria.vue?vue&type=script&lang=js"

import "./3.Austria.vue?vue&type=style&index=0&id=fb52e2d6&lang=css"
import "./3.Austria.vue?vue&type=style&index=1&id=fb52e2d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb52e2d6"]])

export default __exports__